import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import type { IClickToText } from 'entities/ClickToText'
import { ClickToTextApi } from 'entities/ClickToText/api/clickToText'
import { DetailsClickToTextModal } from 'pages/clickToText/pages/all/ui/ClickToTextModals'

export class ClickToTextActionsStore {
  constructor() {
    makeAutoObservable(this)
  }

  onDetails = (clickToText: IClickToText) => {
    modalStore.addModal({
      id: nanoid(),
      width: 540,
      position: 'right',
      type: ModalTypeList.DEFAULT,
      ModalContentProps: { clickToText },
      ModalContent: DetailsClickToTextModal,
      title: 'Details',
      pureContent: true,
      fullHeight: true,
    })
  }

  onDelete = (clickToText: IClickToText, onSuccess?: () => void) => {
    const id = nanoid()
    modalStore.addModal({
      id: id,
      type: ModalTypeList.ALERT,
      title: 'Delete Link',
      desc: `Are you sure you want to delete '${clickToText.name}'? If you delete it, the link and QR code connected to it will no longer work.`,
      primaryAction: {
        text: 'Delete',
        onAction: async () => {
          try {
            await ClickToTextApi.deleteClickToText(clickToText.id)
            toastStore.add({
              type: 'success',
              title: 'Link deleted',
            })
            onSuccess && onSuccess()
            modalStore.closeModal(id)
          } catch (error) {
            logger.error(error)
          }
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          modalStore.closeModal(id)
        },
      },
    })
  }
}
